const BASE_DOMAIN = 'xiaoman.cn'
const OKKI_DOMAIN = 'okki.com'
const OKKI_AI_DOMAIN = 'okki.ai'

const serverConfigs = {
  development: {
    oss: localStorage.getItem('test_oss_api') || '//oss-api.dev.xiaoman.cn',
    crm: `//crm.dev.${BASE_DOMAIN}`
  },
  release: {
    oss: `https://pre-oss-api.${BASE_DOMAIN}`,
    crm: `https://crm.${BASE_DOMAIN}`
  },
  production: {
    oss: `https://oss-api.${BASE_DOMAIN}`,
    crm: `https://crm.${BASE_DOMAIN}`
  }
};

const servers = serverConfigs[process.env.NODE_ENV] || serverConfigs.production;

// 兼容在okki.com域名下访问
if (location.origin.includes('okki.com')) {
  if (process.env.NODE_ENV === 'release') {
    servers['oss'] = 'https://oss-api.beta.okki.com'
  }
  Object.keys(servers).forEach(key => {
    servers[key] = servers[key].replace(BASE_DOMAIN, OKKI_DOMAIN)
  })
} else if (location.origin.includes('okki.ai')) {
  Object.keys(servers).forEach(key => {
    servers[key] = servers[key].replace(BASE_DOMAIN, OKKI_AI_DOMAIN)

    if (key === 'crm') {
      // dev 环境crm 接口默认是https://crm-iteration-5-6-1110391.story.dev.okki.ai
      if (process.env.NODE_ENV === 'development') {
        servers[key] = servers[key].replace('oss-api', 'crm-iteration-5-6-1110391.story')
      } else {
        servers[key] = servers[key].replace('crm', 'io')
      }
    } else if (key === 'oss') {
      if (process.env.NODE_ENV !== 'development') {
        servers[key] = 'https://io.okki.ai/os-api'
      } else if (process.env.NODE_ENV === 'release') {
        servers[key] = 'https://oss-api.beta.okki.ai/os-api'
      } else {
        servers[key] = servers[key] + '/os-api'
      }
    }
  })
}

export default servers;
